type AvatarOthers = {
  id: number;
  userId: string;
  name: string;
  image: string;
  num?: number;
  emoji?: string;
  tags?: string[];
};

export const AVATAR_LINK: { my: string; others: AvatarOthers[] } = {
  my: 'https://womophoto.s3.amazonaws.com/j78/2021-06-24/110/soN5oVpMMW1NOsZ_1624506345.jpeg',
  others: [
    {
      id: 1,
      userId: 'dora1314',
      name: '朵拉公主',
      image:
        'https://images.unsplash.com/photo-1653032921901-4286b88b676c?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OTR8fGtvcmVhJTIwZ2lybHxlbnwwfHwwfHx8Mg%3D%3D',
      num: 1,
      emoji: '😄',
      tags: ['多年閨蜜', '失戀避風港', '今世情人'],
    },
    {
      id: 2,
      userId: 'joannaLoveU',
      name: '喬妹',
      image:
        'https://images.unsplash.com/photo-1750231210987-485cca56b3b7?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OTd8fGtvcmVhJTIwZ2lybHxlbnwwfHwwfHx8Mg%3D%3D',
      num: 24,
      emoji: '😍',
      tags: ['麻將好咖', '最佳損友', '帶我吃香喝辣'],
    },
    {
      id: 3,
      userId: 'cherryGoFighting',
      name: 'Cherry',
      image:
        'https://images.unsplash.com/photo-1728546679568-5f5d7a3c1ec2?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTYyfHxrb3JlYSUyMGdpcmx8ZW58MHx8MHx8fDI%3D',
      num: 468,
      emoji: '😝',
      tags: ['情緒垃圾桶', '幹話老友'],
    },
    {
      id: 4,
      userId: 'dora1sss314',
      name: '朵拉欸',
      image:
        'https://images.unsplash.com/photo-1653032921901-4286b88b676c?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OTR8fGtvcmVhJTIwZ2lybHxlbnwwfHwwfHx8Mg%3D%3D',
      num: 52,
      emoji: '😄',
      tags: ['多年閨蜜', '失戀避風港', '今世情人'],
    },
    {
      id: 5,
      userId: 'joannaLdddoveU',
      name: '喬妹妹妹',
      image:
        'https://images.unsplash.com/photo-1750231210987-485cca56b3b7?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OTd8fGtvcmVhJTIwZ2lybHxlbnwwfHwwfHx8Mg%3D%3D',
      num: 11,
      emoji: '😍',
      tags: ['麻將好咖', '最佳損友', '帶我吃香喝辣'],
    },
    {
      id: 6,
      userId: 'cherryGosssFighting',
      name: 'Cherryaa',
      image:
        'https://images.unsplash.com/photo-1728546679568-5f5d7a3c1ec2?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTYyfHxrb3JlYSUyMGdpcmx8ZW58MHx8MHx8fDI%3D',
      num: 468,
      emoji: '😝',
      tags: ['情緒垃圾桶', '幹話老友'],
    },
  ],
};
